import { AbstractGenerateWorkplaceEntitiesStep } from './abstract-generate-workplace-entities-step';

export class GenerateWorkplaceProtectiveEquipmentsStep extends AbstractGenerateWorkplaceEntitiesStep {

}
